export default __webpack_public_path__ + "static/media/redCross.940e60b9.jpg";